import { arrayify } from '@sonar-software/sonar-ts-lib';
import { createAsyncSelectors } from '@lib/selectors';
import { ExportButton } from '@ui/general/ExportButton';
import React from 'react';

import { coreActions, PostDataSecurityAccessComparisonExportRequest } from '@sonar-software/sonar-core';

export interface AccessComparisonExportButtonProps {
	queryParams: PostDataSecurityAccessComparisonExportRequest;
}

const exportStartSelectors =
createAsyncSelectors((state) => state.core.dataSecurity.dataAccess.accessComparison.export.post);

export const AccessComparisonExportButton: React.FC<AccessComparisonExportButtonProps> = ({ queryParams }) => {
	const { accessId, accessType, filters = '', objectId, ordering = '' } = queryParams;

	// Transform ordering from ObjectName to ObjectLabel for export
	const transformedOrdering = ordering ?
		ordering.replace(/ObjectName/gu, 'ObjectLabel') :
		'ObjectLabel~a';

	const request: PostDataSecurityAccessComparisonExportRequest = {
		accessId: arrayify(accessId),
		accessType: arrayify(accessType),
		filters,
		objectId,
		ordering: transformedOrdering
	};

	return (
		<ExportButton
			buttonProps={ {
				id: 'access-comparison-export-button',
				type: 'primary'
			} }
			onStartExport={ coreActions.requestPostCoreDataSecurityAccessComparisonExport }
			request={ request }
			resetExport={ coreActions.resetPostCoreDataSecurityAccessComparisonExport }
			stateSelector={ exportStartSelectors.state } />
	);
};
